export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

export function formatUsd(amount: number, digits = 3): string {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "$—";
  return `$${n.toFixed(digits)}`;
}

export function uniqueBy<T>(items: T[], keyOf: (item: T, index: number) => string): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const key = String(keyOf(item, i) ?? "").trim();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
}
